



































































































































































import { Component, Mixins } from "vue-property-decorator";
import Search from "@/components/elements/utility/Search.vue";
import DataTable from "@/components/elements/utility/Table.vue";
import UserService from "@/services/user_service";
import { LineItem, Order } from "@/models/order/order";
import { makeTitleCase } from "@/utility/helpers";
import { OrderStatus } from "@/models/order/helpers";
import { NetSuiteQuoteStatus } from "@/models/netsuite/helpers";
import { Mobile } from "@/mixins/mobile";
import ConfirmClearAll from "@/components/elements/modal/ConfirmClearAll.vue";
import { OrderMixin } from "@/mixins/orders/mixin";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { GlobalGetters } from "@/store/modules/global/types";
import { Roles } from "@/models/user/roles";

@Component({
  components: {
    Search,
    DataTable,
    ConfirmClearAll
  }
})
export default class OrderList extends Mixins(Mobile, OrderMixin) {
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetRole))
  userRole!: string;

  protected makeTitleCase = makeTitleCase;
  protected orderStatus = OrderStatus;
  protected userService = new UserService();
  protected orderStatusKeys = Object.keys(OrderStatus);
  protected loader: any = null;
  private unofficialOrders: Order[] = [];

  protected tabs = [
    { key: NetSuiteQuoteStatus.Open, label: "Open" },
    { key: NetSuiteQuoteStatus.Processed, label: "Processed" },
    { key: NetSuiteQuoteStatus.Expired, label: "Expired" },
    { key: "Legacy", label: "Legacy" }
  ];

  async created(): Promise<void> {
    const label = this.userRole === "admin" ? "All" : "My";
    this.loader = this.$loading.show(
      { opacity: 1 },
      {
        before: this.$createElement("h1", `Obtaining ${label} Quotes`)
      }
    );
    await this.prepareNetSuiteQuotes();
    try {
      this.unofficialOrders = await this.userService.getUserOrders(this.userRole);
    } catch (err) {
      console.warn("Legacy quotes unavailable:", err);
      this.unofficialOrders = [];
    }
    this.orders = this.netSuiteQuotes.concat(this.unofficialOrders);
    setTimeout(() => this.loader.hide(), 300);
  }

  protected async prepareNetSuiteQuotes(): Promise<void> {
    try {
      let userNetSuiteQuotes: any[] = [];

      if (this.userRole === Roles.Admin) {
        userNetSuiteQuotes = await this.netSuiteService.getAllNetSuiteQuotes();
      } else if (this.user.netsuite_id) {
        userNetSuiteQuotes = await this.netSuiteService.getMyQuotes();
      }

      this.convertNetSuiteQuotes(userNetSuiteQuotes || []);
    } catch (err) {
      console.error("Error preparing NetSuite quotes:", err);
    }
  }

  protected getMultiplier(
    items: LineItem[],
    price_level_discount?: number
  ): number {
    if (price_level_discount !== undefined) {
      return parseFloat((1 + price_level_discount).toFixed(4));
    }
    // 11/3/2023_FUPOF-137: Quotes are to have the same multiplier for all items.
    if (items.length > 0 && items[0].multiplier) {
      return items[0].multiplier;
    }
    return 1;
  }
}
